/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconIndentIncrease = createReactComponent("indent-increase", "IconIndentIncrease", [
  ["path", { d: "M20 6l-11 0", key: "svg-0" }],
  ["path", { d: "M20 12l-7 0", key: "svg-1" }],
  ["path", { d: "M20 18l-11 0", key: "svg-2" }],
  ["path", { d: "M4 8l4 4l-4 4", key: "svg-3" }]
]);

export { IconIndentIncrease as default };
//# sourceMappingURL=IconIndentIncrease.js.map
